export default {"src":"/static/spa/fresh-spa/_next/static/media/icon-ten-ingredients.5f3ad866.svg","height":63,"width":70,"blurWidth":0,"blurHeight":0};